@for (errorKey of commonErrorsKey; track errorKey) {
  <sd-form-error
    [control]="control"
    [errorKey]="errorKey"
    [errorLabel]="getLabel(errorKey)"
  />
}
